import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AIEngineeringServicePage from "@/pages/service/AIEngineeringServicePage";

export const Route = createFileRoute("/service/ai-engineering")({
  head: () => pageHead("AI Engineering Services & Consulting", "AI engineering and consulting firm delivering full-cycle AI: custom development, multi-agent systems, agentic operations, computer vision, and production AI infrastructure.", "/service/ai-engineering", false),
  component: AIEngineeringServicePage,
});
